/**
 * Artifact Status Value Object - Following GTD Pattern
 * Represents the lifecycle state of an artifact in the design-implementation flow
 */
export class ArtifactStatus {
  private constructor(
    public readonly status: string,
    public readonly displayName: string,
    private readonly allowedTransitions: string[]
  ) {}

  static planning(): ArtifactStatus {
    return new ArtifactStatus('planning', 'Planning', ['development', 'review']);
  }

  static development(): ArtifactStatus {
    return new ArtifactStatus('development', 'Development', ['review', 'production', 'planning']);
  }

  static review(): ArtifactStatus {
    return new ArtifactStatus('review', 'Review', ['production', 'development']);
  }

  static production(): ArtifactStatus {
    return new ArtifactStatus('production', 'Production', ['deprecated']);
  }

  static deprecated(): ArtifactStatus {
    return new ArtifactStatus('deprecated', 'Deprecated', []);
  }

  static fromString(status: string): ArtifactStatus {
    switch (status) {
      case 'planning': return ArtifactStatus.planning();
      case 'development': return ArtifactStatus.development();
      case 'review': return ArtifactStatus.review();
      case 'production': return ArtifactStatus.production();
      case 'deprecated': return ArtifactStatus.deprecated();
      default: throw new Error(`Invalid artifact status: ${status}`);
    }
  }

  canTransitionTo(newStatus: string): boolean {
    return this.allowedTransitions.includes(newStatus);
  }

  equals(other: ArtifactStatus): boolean {
    return this.status === other.status;
  }

  toString(): string {
    return this.status;
  }
}